// services
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
// models
import { ToastrService } from 'ngx-toastr';
//rxjs
import { NgClass, NgStyle } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Notification } from '../../../../_shared/model/notification.model';
import { DatePipe } from '../../../../_shared/pipes/date.pipe';
import { StorageService } from '../../../../_shared/services';
import { HelperNotificationService } from '../../../../_shared/services/helper-notification.service';
import { BusinessSubjectIconComponent } from '../../../components/business-subject-icon/business-subject-icon.component';
import { NotificationService } from '../../../pages/home/_services';

@Component({
    selector: 'app-header-notification-element',
    templateUrl: './header-notification-element.component.html',
    styles: [],
    imports: [NgbTooltip, NgClass, NgStyle, DatePipe, BusinessSubjectIconComponent],
})
export class HeaderNotificationElementComponent {
    private storage = inject(StorageService);
    private notifRest = inject(NotificationService);
    private notificationHelper = inject(HelperNotificationService);
    private toast = inject(ToastrService);

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public messageClick: EventEmitter<any> = new EventEmitter();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onMessageNavigate: EventEmitter<any> = new EventEmitter();

    @Input() public notification: Notification;
    @Input() public index: number;

    public messageRead(): void {
        this.messageClick.emit(this.index);
    }

    public redirectSwitch(): void {
        this.notifRest.markNotificationAsSeen(this.storage.getSelectedContractor().id, this.notification.id).subscribe();

        this.notificationHelper.redirectSwitch(this.notification);

        this.onMessageNavigate.emit(true);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public copyPreId(event: any) {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let nav: any;
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line prefer-const
        nav = window.navigator;
        let text = event.target.textContent.trim();
        if (!text) {
            return;
        }
        if (text.includes('ID:')) {
            text = text.split('ID:')[1].trim();
        }
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        nav.clipboard.writeText(text).then(function () {});
        this.toast.info('Šifra dodana v odložišče.');
    }
}
